/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioHeadsetIcon16Solid = forwardRef('MediaAudioHeadsetIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 0a7 7 0 0 0-7 7v3.25c0 .966.784 1.75 1.75 1.75h1.5A1.75 1.75 0 0 0 6 10.25v-2.5A1.75 1.75 0 0 0 4.25 6H3.1a5.002 5.002 0 0 1 9.8 0h-1.15A1.75 1.75 0 0 0 10 7.75v2.5c0 .966.784 1.75 1.75 1.75h1.08A3.001 3.001 0 0 1 10 14h-.085A1.5 1.5 0 0 0 8.5 13h-1a1.5 1.5 0 0 0 0 3H10a5 5 0 0 0 5-5V7a7 7 0 0 0-7-7Z" })));
});
